export const es = {
  urgency: {
    label: 'PRECIO DE LANZAMIENTO TERMINA EN',
    priceNote: '· $17 (REG. $34)',
  },
  hero: {
    badge: 'EDICIÓN 2026',
    kicker: 'PARA PERSONAS COMUNES',
    title1: 'EL PLAN DE',
    title2: 'INGRESOS',
    title3: 'CON IA',
    subtitle:
      'Deja de comprar cursos de IA de $997. Las personas que realmente generan ingresos con ChatGPT y Claude usan un PDF de $17. 7 caminos probados. Plan de 30 días. 100 prompts. Para personas comunes.',
    stats: [
      { num: '7', label: 'CAMINOS DE INGRESO' },
      { num: '30', label: 'DÍAS DE PLAN' },
      { num: '100', label: 'PROMPTS' },
    ],
    cta: 'OBTÉN EL PLAN · $17',
    priceNote: 'El precio de lanzamiento termina pronto. PDF instantáneo.',
  },
  empathy: {
    kicker: 'SI HAS SENTIDO ESTO',
    title: 'NO ESTÁS ATRASADO. SOLO TE FALTA EL SISTEMA.',
    p1: 'Has visto a tres amigos mencionar ChatGPT este mes. Lo probaste y pareció un juguete. Cerraste la pestaña.',
    p2: 'Sigues viendo publicaciones sobre "ganar $10K/mes con IA" y pones los ojos en blanco. Con razón. La mayoría es puro humo.',
    p3: 'Pero también sabes que la oportunidad es real, y las personas que realmente ganan dinero con IA no son las que más ruido hacen en internet.',
  },
  problem: {
    kicker: 'POR QUÉ LA MAYORÍA FRACASA',
    title: 'LAS 3 RAZONES POR LAS QUE EL 80% SE RINDE EN LA SEMANA 3',
    cards: [
      {
        num: '01',
        title: 'INTENTAN LOS 7 CAMINOS A LA VEZ',
        desc: 'Síndrome del objeto brillante. Elige uno, termínalo y luego suma otro.',
      },
      {
        num: '02',
        title: 'COBRAN POR EL RESULTADO, NO POR EL IMPACTO',
        desc: "Nadie paga por 'usé ChatGPT'. Pagan por resultados.",
      },
      {
        num: '03',
        title: 'PUBLICAN BASURA EVIDENTE DE IA',
        desc: 'La edición es el 70% del valor. Si la omites, Google te penaliza.',
      },
    ],
  },
  mechanism: {
    kicker: 'EL PLAN',
    title: 'HABILIDAD × VELOCIDAD × DISTRIBUCIÓN',
    subtitle:
      'Los ingresos con IA a cualquier escala se reducen a multiplicar tres números. Si alguno es cero, tus ingresos son cero.',
    cards: [
      { title: 'HABILIDAD', desc: 'Lo que realmente puedes entregar' },
      {
        title: 'VELOCIDAD',
        desc: 'La IA te hace de 3x a 10x más rápido. Aquí es donde está el margen.',
      },
      {
        title: 'DISTRIBUCIÓN',
        desc: 'Cómo te encuentran los compradores. Lo principal que la mayoría ignora.',
      },
    ],
    note: 'La mayoría arregla la habilidad primero. Ese es el orden incorrecto. Arregla la distribución primero. Tu habilidad mejorará con el trabajo real de los clientes.',
  },
  productReveal: {
    kicker: 'PRESENTANDO',
    title1: 'EL LIBRO CREADO PARA',
    title2: 'PERSONAS QUE NO TIENEN TIEMPO QUE PERDER.',
    desc: '65 páginas de exactamente lo que funciona. Sin relleno. Sin humo. Sin teoría que ya leíste en Twitter.',
    bullets: [
      '7 caminos de ingresos probados con flujos de trabajo reales',
      'Plan de 30 días con listas de verificación diarias',
      '100 prompts listos para copiar y pegar organizados por camino',
      '3 hojas de trabajo para mantenerte enfocado',
    ],
    cta: 'OBTÉN EL PLAN · $17',
    priceNote: '50% PRECIO DE LANZAMIENTO. Descarga instantánea en PDF.',
  },
  whatsInside: {
    kicker: 'LO QUE OBTIENES',
    title1: '65 PÁGINAS.',
    title2: 'CERO RELLENO.',
    cards: [
      {
        num: '01',
        title: '7 CAMINOS DE INGRESO',
        desc: 'Escritura freelance, redes sociales para negocios locales, productos digitales, servicios hechos para ti, automatización con IA, coaching, creación de contenido',
      },
      {
        num: '02',
        title: 'PLAN DE LANZAMIENTO DE 30 DÍAS',
        desc: 'Calendario día a día desde la configuración hasta el primer cliente de pago',
      },
      {
        num: '03',
        title: 'BÓVEDA DE 100 PROMPTS',
        desc: 'Prompts para copiar y pegar organizados por camino, variables resaltadas',
      },
      {
        num: '04',
        title: '3 HOJAS DE TRABAJO',
        desc: 'Selector de Camino, Rastreador de los Primeros $500, Rastreador del Plan de 30 Días',
      },
    ],
  },
  whoItsFor: {
    kicker: '¿ERES TÚ?',
    title: 'CREADO PARA 4 TIPOS DE PERSONAS.',
    cards: [
      {
        title: 'EL FALTO DE TIEMPO',
        desc: '5-10 hrs/semana, necesita ingresos que funcionen sin supervisión constante',
      },
      {
        title: 'EL RICO EN HABILIDADES',
        desc: 'Ya es bueno en algo, quiere que la IA multiplique su experiencia',
      },
      {
        title: 'EL PRINCIPIANTE LUCHADOR',
        desc: 'Lleno de energía, se esforzará por conseguir su primer cliente',
      },
      {
        title: 'EL CONSTRUCTOR',
        desc: 'Le gustan los sistemas y las automatizaciones, piensa en flujos de trabajo',
      },
    ],
    note: 'Si te ves reflejado en alguno de estos, estás en el lugar correcto. El libro te mostrará cuál de los 7 caminos coincide con tu perfil.',
  },
  founder: {
    kicker: 'QUIÉN ESCRIBIÓ ESTO',
    title: 'CESAR NAVARRO. CONSTRUIDO CON IA.',
    desc: 'Soy Cesar. He pasado el último año construyendo flujos de ingresos reales usando ChatGPT y Claude, y documentando lo que funcionó. El Plan no es teoría. Son los 7 caminos exactos que he visto a la gente ejecutar en 2025 y 2026, con los prompts, los flujos de trabajo y los guiones para el primer cliente. Escribí este libro usando las mismas herramientas de IA que enseño. Es la prueba de que los métodos funcionan.',
    badge1: 'Autor',
    badge2: 'Cesar Navarro',
  },
  testimonials: {
    kicker: 'LO QUE DICEN LOS COMPRADORES',
    title: 'PERSONAS REALES. RESULTADOS REALES.',
    items: [
      {
        quote:
          'Había comprado tres cursos de $997 antes de este. Ninguno me dio un sistema. El Plan me consiguió mi primer cliente de $500 en la semana 3 usando el Camino #2. Vale 50 veces lo que pagué.',
        result: 'Primer cliente de $500 en 3 semanas',
        name: 'Sarah M.',
        role: 'Redactora freelance',
        initials: 'SM',
      },
      {
        quote:
          'Por fin una guía que no pierde el tiempo. El plan de 30 días es lo más útil. Sabía exactamente qué hacer cada día. Gané $1,200 en mi primer mes usando el camino de negocios locales.',
        result: '$1,200 primer mes',
        name: 'David K.',
        role: 'Freelancer de marketing',
        initials: 'DK',
      },
      {
        quote:
          'No soy “una persona técnica”. Había abandonado la IA dos veces antes de esto. La bóveda de 100 prompts por sí sola vale los $17. Copio, pego, edito y termino en 20 minutos.',
        result: '10x más rápido con prompts',
        name: 'Jessica R.',
        role: 'Mamá emprendedora',
        initials: 'JR',
      },
      {
        quote:
          'Sinceramente, era escéptico al precio de $17. Pensé que sería un PDF de 10 páginas. Son 65 páginas de pura ejecución. Soy ingeniero de software y aprendí 3 nuevos flujos. Cancelé mi suscripción a Skool.',
        result: 'Reemplazó suscripción de $97/mes',
        name: 'Marcus T.',
        role: 'Ingeniero de software',
        initials: 'MT',
      },
    ],
    footnote:
      'Cada testimonio anterior es de un comprador verificado. Nunca pagamos por reseñas ni usamos fotos de archivo. Los resultados varían según el esfuerzo y la consistencia.',
  },
  difference: {
    kicker: 'NO COMO OTROS LIBROS',
    title1: 'LA MAYORÍA DE LOS LIBROS DE IA SON GENÉRICOS.',
    title2: 'ESTE ES ESPECÍFICO.',
    col1: 'Libros típicos de IA',
    col2: 'El Plan',
    rows: [
      {
        bad: 'Consejos genéricos de ChatGPT',
        good: 'Prompts específicos por camino de ingresos',
      },
      { bad: 'Teoría y humo', good: 'Plan de ejecución día a día de 30 días' },
      { bad: 'Solo cubre ChatGPT', good: 'Cubre TANTO ChatGPT como Claude' },
    ],
  },
  offer: {
    kicker: 'OBTÉN EL LIBRO',
    title: 'UN SOLO PAGO. $17. TUYO PARA SIEMPRE.',
    badge: '50% PRECIO DE LANZAMIENTO',
    includes: [
      'PDF de 65 páginas (acceso de por vida, actualizaciones de por vida)',
      '7 caminos de ingresos con flujos de trabajo, prompts, guiones para el primer cliente',
      'Plan de lanzamiento de 30 días con listas de verificación diarias',
      '100 prompts listos para copiar y pegar organizados por camino',
      '3 hojas de trabajo imprimibles (Selector de Camino, Rastreador de $500, Rastreador de 30 Días)',
      'Lista de verificación adicional "Cómo empezar el lunes"',
    ],
    bump: {
      kicker: '// OFERTA ÚNICA',
      yes: 'SÍ, agregar los',
      name: '50 Power Prompts',
      price: 'por solo +$10',
      retail: '(normalmente $17)',
      desc: '50 prompts profundos y listos para producción en 10 categorías. La bóveda complementaria al Plan. Copia, pega y obtén resultados el mismo día. Solo se ofrece a este precio aquí mismo.',
    },
    ctaBump: 'OBTÉN EL PLAN + 50 PROMPTS · $27',
    ctaNormal: 'OBTÉN EL PLAN · $17',
    trustBadges: [
      'DESCARGA INSTANTÁNEA EN PDF',
      'REEMBOLSO DE 30 DÍAS',
      'PAGO SEGURO',
    ],
    guaranteeTitle: 'La Garantía "Sin Rodeos"',
    guaranteeDesc:
      'Si terminas el plan de 30 días y no consigues ni un solo cliente de pago, envíame un correo. Te reembolsaré Y te enviaré una llamada de estrategia de 30 minutos gratis. Sin preguntas, sin formularios, sin problemas.',
  },
  faq: {
    kicker: 'PREGUNTAS FRECUENTES',
    title: 'PREGUNTAS ANTES DE COMPRAR.',
    items: [
      {
        q: '¿ES ESTO PARA PRINCIPIANTES TOTALES?',
        a: 'Sí, pero las personas con habilidades previas le sacan más provecho más rápido.',
      },
      {
        q: '¿NECESITO SER TÉCNICO?',
        a: 'No. Nada en este libro requiere saber programar.',
      },
      {
        q: '¿CHATGPT O CLAUDE?',
        a: 'Ambos. El libro explica exactamente cuándo usar cada uno.',
      },
      {
        q: '¿HAY REEMBOLSO?',
        a: 'Sí, 7 días sin preguntas. Más la garantía de 30 días mencionada arriba.',
      },
      {
        q: '¿CUÁNTO TIEMPO HASTA VER RESULTADOS?',
        a: '30 días si sigues el plan exactamente.',
      },
      {
        q: '¿LAS VENTAS ADICIONALES SON OBLIGATORIAS?',
        a: 'No. El libro es 100% independiente. Las ventas adicionales son extras opcionales.',
      },
    ],
  },
  finalCta: {
    title1: 'EMPIEZA',
    title2: 'EL LUNES.',
    cta: 'OBTÉN EL PLAN · $17',
    desc: 'Sin cursos. Sin comunidad. Sin ventas adicionales obligatorias. Solo el plan. $17.',
  },
  footer: {
    brand1: 'SIMPLE',
    brand2: 'SOLUTIONS',
    links: [
      { label: 'Política de Privacidad' },
      { label: 'Términos de Servicio' },
      { label: 'Contacto' },
    ],
  },
}
